import { capitalize as _capitalize } from 'lodash-es';

export function titleCase(text: string) {
  return _capitalize(text.split('_').join(' '));
}
